<template>
    <span class="login">@{{ value }}</span>
</template>

<script>
export default {
    props: {
        value: String
    }
}
</script>

<style lang="scss">
.login {
    color: #208024;
    font-size: 13px;
}
</style>